// Delaferia 2026 v2 — theme.js global
// Autor: Antonio Aedo — SMTP Chile
// El JS por section vive dentro de cada sections/*.liquid con {% javascript %}
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
})();
